import { UserModel, UserRoleModel, } from 'shared/definition';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpinningService } from 'shared/services';
import { switchMap, tap } from 'rxjs/operators';
import { onFormSubmit } from 'shared/utils';
import { CurrentUserApiService } from 'shared/services/current-user-api.service';
import { __isMobile } from 'shared/consts/__is-mobile';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { RoleApiService } from 'app/modules/configuration/service';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { TranslateService } from '@ngx-translate/core';
import { UserType, UserTypeConstant } from 'shared/enums/user-type.enum';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {

    size = {
        label: '130px',
        control: 'auto'
    };
    editMode: boolean;
    form: FormGroup;
    orgNodes: NzTreeNodeOptions[] = [];
    currentUser: UserModel;
    roleList: UserRoleModel[];
    userTypeOptions: any;
    selectedNodeId: string;
    userTypeConstant = UserTypeConstant;
    autoTips: Record<string, Record<string, string>> = {
        'zh-cn': {
            required: '必填项'
        },
        en: {
            required: 'Input is required'
        },
        default: {
            email: this.translate.instant('Login.MailInvalid')
        }
    };

    @ViewChild("parentTree") parentTree: NzTreeSelectComponent;
    private fb: FormBuilder;

    protected userApi: CurrentUserApiService;
    protected spinningService: SpinningService;
    constructor(
        protected injector: Injector,
        private roleApi: RoleApiService,
        private translate: TranslateService
    ) {
        // this.modalRef = __isMobile ? injector.get(NzDrawerRef) : injector.get(NzModalRef);
        this.fb = injector.get(FormBuilder);
        const { email, mobile } = MyValidators;
        this.userApi = injector.get(CurrentUserApiService);
        this.spinningService = injector.get(SpinningService);
        this.form = this.fb.group({
            'userName': this.fb.control(undefined, [Validators.required]),
            'jobNumber': this.fb.control(undefined, [Validators.pattern('[0-9]{4}')]),
            'realName': this.fb.control(undefined, [Validators.maxLength(50)]),
            'phoneNumber': this.fb.control(undefined, [
                mobile,
            ]
            ),
            'roles': this.fb.control(undefined, []),
            'userType': this.fb.control(undefined,[Validators.maxLength(50)])
        });
        for (const key in this.form.controls) {
            if (key == "phoneNumber" || key == "realName" || key == "position" || key == "email" || key == "jobNumber") continue;
            this.form.controls[key].disable();
        }
    }

    protected get modalRef(): NzModalRef | NzDrawerRef {
        return __isMobile ? this.injector.get(NzDrawerRef) : this.injector.get(NzModalRef);
    }

    async ngOnInit() {
        this.userApi.get().subscribe(async user => {
            this.roleList = await this.roleApi.getCurrentRoles().toPromise();
            this.userTypeOptions = Object.keys(UserType).map(key => ({label: key, value: UserType[key]}));
            this.currentUser = user;
            this.form.patchValue(user);
        });
    }

    onChange($event: string): void {

    }

    save() {
        onFormSubmit(this.form);
        if (!this.form.valid) return;
        this.spinningService.startWith(this.userApi.update({
            ...this.currentUser,
            ...this.form.value
        })).pipe(
            switchMap(() => this.userApi.get()),
            tap(user => {
                this.form.patchValue(user);
                this.modalRef.close();
            })
        ).subscribe();

    }


    cancel() {
        this.modalRef.close();
    }

}
// current locale is key of the MyErrorsOptions
export type MyErrorsOptions = { 'zh-cn': string; en: string } & Record<string, NzSafeAny>;
export type MyValidationErrors = Record<string, MyErrorsOptions>;

export class MyValidators extends Validators {

    static mobile(control: AbstractControl): MyValidationErrors | null {
        const value = control.value;

        if (isEmptyInputValue(value)) {
            return null;
        }

        return isMobile(value)
            ? null
            : { mobile: { 'zh-cn': `手机号码格式不正确`, en: `Mobile phone number is not valid` } };
    }
}

function isEmptyInputValue(value: NzSafeAny): boolean {
    return value == null || value.length === 0;
}

function isMobile(value: string): boolean {
    return typeof value === 'string' && /(^1\d{10}$)/.test(value);
}
